import React from "react";
import "./App.css";
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { PortfolioSection } from './components/PortfolioSection';
import { ServicesSection } from './components/ServicesSection';
import { ClientsSection } from './components/ClientsSection';
import { ProfilePage } from './components/ProfilePage';
import { TestimonialsSection } from './components/TestimonialsSection';
import { CareersSection } from './components/CareersSection';
import { ContactSection } from './components/ContactSection';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <PortfolioSection />
      <ClientsSection />
      <ProfilePage />
      <TestimonialsSection />
      <CareersSection />
      <ContactSection />
      <Toaster />
    </div>
  );
}

export default App;
